import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { routePaths as routes } from '../../utilities/routePaths'
import { withRouter } from 'react-router-dom'

export const ShareFeedback = ({ history }) => (
  <React.Fragment>
    <h2>Share your feedback, help us improve</h2>
    <p>
      We have launched our new complaint forms, and would appreciate your
      feedback. Please tell us about your experience and provide any
      recommendations on how we can improve the website. Thank you for taking
      the time to help us improve our complaint process.
    </p>
    <Button
      variation="primary"
      data-testid="feedback-form"
      onClick={() => history.push(routes.feedback.form)}
      className="ds-u-margin-bottom--2 ds-u-margin-top--2"
    >
      Share feedback
    </Button>
  </React.Fragment>
)

export default withRouter(ShareFeedback)
